import { createFileRoute } from "@tanstack/react-router";
import FractionalCmo, { DESCRIPTION, FRACTIONAL_CMO_SCHEMA, TITLE, faq } from "@/pages/FractionalCmo";
import { faqSchema, pageHead } from "@/lib/seo";

export const Route = createFileRoute("/fractional-cmo")({
  head: () =>
    pageHead({
      path: "/fractional-cmo",
      title: TITLE,
      description: DESCRIPTION,
      crumbs: [["Fractional CMO", "/fractional-cmo"]],
      schemas: [...FRACTIONAL_CMO_SCHEMA, faqSchema(faq)],
    }),
  component: FractionalCmo,
});
